var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-search',{ref:"search",attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"autocomplete":true,"autocompleteConfig":_vm.autocompleteConfiguration,"callback":_vm.onSubmit,"enterLocked":true}})}
var staticRenderFns = []

export { render, staticRenderFns }